import Disponibilita from '../../components/Disponibilita/ViewDisponibilita';

export default function DisponibilitaPage() {

    return (
        <Disponibilita></Disponibilita>
    )
}